<script setup lang="ts">
const props = defineProps<{
  title: string,
  desc: string,
  items: Array<{
    title: string,
    desc: string,
    img: string,
    groups: Array<{
        title: string,
        desc: string
    }>
  }>
}>();
const device = useDevice();
</script>

<template>
    <SectionsBase id="features" class="container relative">
        <ChipsDivider>ویژگی‌ها</ChipsDivider>
        <h2>{{ props.title }}</h2>
        <p class="text-body1-semibold text-gray-400 text-center my-6">{{ props.desc }}</p>
        <ClientOnly>
            <LazySectionsFeaturesCrmMobile v-if="!device.isDesktop.value" :items="props.items" />
            <LazySectionsFeaturesCrmDesktop v-else :items="props.items" />
        </ClientOnly>
    </SectionsBase>
</template>